export const categories = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    description: "Discover trending sneakers and footwear collections",
    imageSeq: "cat-shoes-01",
  },
  {
    name: "Hoodies / Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    description: "Cozy hoodies and stylish sweaters for every season",
    imageSeq: "cat-hoodies-02",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    description: "Essential tees from classic to streetwear styles",
    imageSeq: "cat-tshirts-03",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    description: "Outerwear pieces from bombers to parkas",
    imageSeq: "cat-jackets-04",
  },
  {
    name: "Pants / Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    description: "Bottoms for every fit and occasion",
    imageSeq: "cat-pants-05",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    description: "Caps, beanies and head accessories",
    imageSeq: "cat-headwear-06",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    description: "Coordinated outfits and matching sets",
    imageSeq: "cat-sets-07",
  },
  {
    name: "Underwear / Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    description: "Essential basics and comfortable innerwear",
    imageSeq: "cat-underwear-08",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    description: "Sports jerseys and athletic wear",
    imageSeq: "cat-jersey-09",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    description: "Complete your look with stylish accessories",
    imageSeq: "cat-accessories-10",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    description: "Backpacks, totes and everyday carry",
    imageSeq: "cat-bags-11",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    description: "Quality belts for every style",
    imageSeq: "cat-belts-12",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    description: "Signature scents and fragrance collections",
    imageSeq: "cat-perfumes-13",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    description: "More amazing finds and miscellaneous items",
    imageSeq: "cat-other-14",
  },
];